<div [formGroup]="parent">
    <div class="form-field">
        <div class="dropdown-control" role="dropdown"
            [attr.aria-describedBy]="(parent.get(controlName).touched && parent.get(controlName).errors) ? pageName+'-'+controlName +'-error': 'lbl-'+pageName+'-'+controlName">
            <label [id]="'lbl-'+pageName+'-'+controlName" class="form-label"
                [attr.for]="pageName+'-'+controlName">{{dropdownConfig['label']}}</label>
            <app-tool-tip-notification *ngIf="informationRequire" class="dropdown-control__tooltip"
                [childId]="informationControlName" [tooltipName]="'informationConfig'"
                [tooltipData]="informationConfig" 
                (onDisplayMobileTooltipEmitter)="displayDrpTooltipMessage()"></app-tool-tip-notification>
        </div>
        <div [ngClass]="pageName == 'cedingFund'  ? 'form-field-select wd-300' : 'form-field-select'">
            <select [attr.disabled]="ddDisabled ? true : null" [formControlName]="controlName" class="form-control"
                aria-required="true"
                [attr.aria-label]="dropdownConfig['label']?dropdownConfig['label']:pageName+'-'+controlName"
                [attr.aria-invalid]="(parent.get(controlName).touched && parent.get(controlName).errors) ? true : false"
                [required]="dropdownConfig['required']" [name]="dropdownConfig['name']"
                [id]="pageName+'-'+dropdownConfig['name']" [(ngModel)]="textValue" (change)="onChange()">
                <option [disabled]="!dropdownConfig['required']" [ngValue]="null">Please select</option>
                <option *ngFor="let option of dropdownConfig['options']" [value]="option.code"
                    [id]="toCamelCase(option.value)">{{option.value}}
                </option>
            </select>
            <i class="icon icon-chevron-down" aria-hidden="true"></i>
        </div>
    </div>
    <div [ngClass]="{'width-43 margin-top-1':(parent.get(controlName).errors.prudentialInvalid || parent.get(controlName).errors.externalInvalid || parent.get(controlName).errors.manyInvalid),
    'width-30': (controlName === 'protectionType')}" class="form-validation-error" *ngIf="parent.get(controlName).touched
                        &&
                    parent.get(controlName).errors">
        <i class="icon icon-error" aria-hidden="true"></i>
        <p [id]="pageName+'-'+controlName +'-error'" *ngIf="parent.get(controlName).errors.required" aria-hidden="false"
            role="error" aria-live="polite">{{dropdownConfig['errorMessage']}}</p>
        <p [id]="pageName+'-'+controlName +'-error'" *ngIf="parent.get(controlName).errors.prudentialInvalid">
            {{dropdownConfig['prudentialInvalid']}}</p>
        <p [id]="pageName+'-'+controlName +'-error'" *ngIf="parent.get(controlName).errors.externalInvalid">
            {{dropdownConfig['externalInvalid']}}</p>
        <p [id]="pageName+'-'+controlName +'-error'" *ngIf="parent.get(controlName).errors.manyInvalid">
            {{dropdownConfig['manyInvalid']}}</p>
    </div>
</div>